// app/javascript/controllers/bios_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "submitGenerate", "submitRemove", "generateBioPlayers", "removePlayers"];

  connect() {
    // console.log('Hello from the bios controller', this.element);
    // console.log('Checkboxes: ', this.checkboxTargets);
    // console.log('Submit button: ', this.submitTarget);

    // Check for player ID in the hash in URL and scroll to that element if found
    const urlParams = new URLSearchParams(window.location.search);
    const playerId = urlParams.get('player_id');
    if (playerId) {
      const element = document.querySelector(`#header-${playerId}`).querySelector('.accordion-button');
      if (element) {
        element.click();
        element.scrollIntoView({behavior: "smooth"});
      }
    }
  }

  togglePlayer(event) {
    const checkedPlayers = this.checkboxTargets.filter((checkbox) => checkbox.checked && !checkbox.disabled).map((checkbox) => parseInt(checkbox.value));
    if (this.hasGenerateBioPlayersTarget) {
      this.generateBioPlayersTargets.forEach((target) => {
        target.value = JSON.stringify(checkedPlayers);
      });
    }
    this.hasRemovePlayersTarget && (this.removePlayersTarget.value = JSON.stringify(checkedPlayers));

    if (checkedPlayers.length > 0) {
      this.submitRemoveTarget.classList.remove('d-none');
      this.submitRemoveTarget.classList.add('d-block');

      if (this.hasSubmitGenerateTarget) {
        this.submitGenerateTarget.removeAttribute('disabled');
      }

    } else {
      this.submitRemoveTarget.classList.remove('d-block');
      this.submitRemoveTarget.classList.add('d-none');

      if (this.hasSubmitGenerateTarget) {
        this.submitGenerateTarget.setAttribute('disabled', true);
      }

    }
  }

  toggleAllPlayers(event) {
    if (event.target.checked === false) {
      this.checkboxTargets.filter((checkbox) => !checkbox.disabled).forEach((checkbox) => {
        checkbox.checked = false;
      });

      if (this.hasGenerateBioPlayersTarget) {
        this.generateBioPlayersTargets.forEach((target) => {
          target.value = JSON.stringify([]);
        });
      }
      this.hasRemovePlayersTarget && (this.removePlayersTarget.value = JSON.stringify([]));

      this.submitRemoveTarget.classList.remove('d-block');
      this.submitRemoveTarget.classList.add('d-none');

      this.submitGenerateTarget.setAttribute('disabled', true);
    } else {
      this.checkboxTargets.filter((checkbox) => !checkbox.disabled).forEach((checkbox) => {
        checkbox.checked = true;
      });

      if(this.hasGenerateBioPlayersTarget) {
        this.generateBioPlayersTargets.forEach((target) => {
          target.value = JSON.stringify(this.checkboxTargets.filter((checkbox) => !checkbox.disabled).map((checkbox) => parseInt(checkbox.value)))
        });
      }
      this.hasRemovePlayersTarget && (this.removePlayersTarget.value = JSON.stringify(this.checkboxTargets.filter((checkbox) => !checkbox.disabled).map((checkbox) => parseInt(checkbox.value))));

      this.submitRemoveTarget.classList.remove('d-none');
      this.submitRemoveTarget.classList.add('d-block');

      this.submitGenerateTarget.removeAttribute('disabled');
    }
  }

}